<footer>
    <div class="container">
      <a class="logo-font" routerLink="/">CRM</a>
      <span class="attribution">
        &copy; {{ today | date: 'yyyy' }}.
      </span>
    </div>
  </footer>
  